import { Popover as APopover, PopoverProps } from "antd";
import React from "react";

const Popover = (props: PopoverProps) => {
  return (
    <APopover autoAdjustOverflow placement='bottom' overlayClassName='cr-popover' {...props} />
  );
};

export default Popover;
